/**
 * Landing Page - Marketing homepage for end customers
 * Targeting small businesses and enterprises needing software licenses
 */
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import { HeroSection, StatsSection } from './LandingHero'
import { ProductsSection, BenefitsSection, FeaturesSection, TestimonialsSection } from './LandingFeatures'
import { PricingSection, CtaSection } from './LandingPricing'

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        <HeroSection />
        <StatsSection />
        <ProductsSection />
        <BenefitsSection />
        <FeaturesSection />
        <TestimonialsSection />
        <PricingSection />
        <CtaSection />
      </main>

      <Footer />
    </div>
  )
}
